import { getProgramTier, isActiveClientAccount } from './accountLifecycle';

export function programBillingStatusKey(account) {
  const raw =
    account.billing?.status ??
    account.program?.subscriptionStatus ??
    account.program?.clientStatus ??
    'active';
  return String(raw).trim().toLowerCase().replace(/\s+/g, '_');
}

/** The program tier (Lite / Plus / Pro / Custom / …) — never a lifecycle word. */
export function programTierLabel(account) {
  return getProgramTier(account);
}

export function normalizeKickoffStatus(account) {
  const s = account.kickoffStatus;
  if (s === 'complete' || s === 'in_review') return s;
  return 'in_review';
}

/**
 * Clients that belong on every CRM fulfillment list (kickoff, roadmaps, collection, meeting
 * mode, portal view, messaging). One rule, from accountLifecycle: a client account that is not
 * Canceled / Lost / Archived (stored, or derived from a cancel date that has passed / Stripe)
 * and not deleted. past_due / incomplete / trialing are still live clients we work with.
 */
export function isKickoffEligibleClient(account) {
  const accountType = account.type || account.accountType;
  if (accountType && (accountType.toLowerCase() === 'leads' || accountType.toLowerCase() === 'lead')) {
    return false;
  }
  if (!(account.type === 'Clients' || !account.type)) return false;
  return isActiveClientAccount(account);
}

/** First segment of tier label (handles plan keys like `lite_monthly`). */
export function messagingCommunityProgramKey(account) {
  const label = String(programTierLabel(account)).trim().toLowerCase();
  return (label.split(/[_\s-]/)[0] || '').trim();
}

const MESSAGING_COMMUNITY_PROGRAM_KEYS = new Set(['custom', 'lite', 'plus', 'pro']);

/**
 * Clients shown in CRM messaging “Community” picker: same eligibility as kickoff/roadmap fulfillment
 * (active client, not ended), and program tier Custom, Lite, Plus, or Pro.
 */
export function isMessagingCommunityClient(account) {
  if (!isKickoffEligibleClient(account)) return false;
  return MESSAGING_COMMUNITY_PROGRAM_KEYS.has(messagingCommunityProgramKey(account));
}
